import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import cfwa from '@/components/cfwa';// cfwa
import cfra from '@/components/cfra';// cfra
import ruleDetaile from '@/components/ruleDetaile';// 研值积分规则
import detaile from '@/components/detaile';// 收益规则详情页和收益规则详情页和绑卡规则
import shop from '@/components/shop';//
import imgDetaile from '@/components/imgDetaile';//收入风险图文详情
import familyimgDetaile from '@/components/familyimgDetaile';//家系图文详情
import invitationShare from '@/components/invitationShare';//邀请分享
import fiveSteps from '@/components/fiveSteps';//养老五步详情
import courseShare from '@/components/courseShare';//课程分享

import reportdetaile from '@/components/reportdetaile';//报告书


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/reportdetaile',
      name: 'reportdetaile',
      component: reportdetaile
    },

    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },{
      path: '/cfwa',
      name: 'cfwa',
      component: cfwa
    },{
      path: '/cfra',
      name: 'cfra',
      component: cfra
    },{
      path: '/ruleDetaile',
      name: 'ruleDetaile',
      component: ruleDetaile
    },{
      path: '/detaile',
      name: 'detaile',
      component: detaile
    },{
      path: '/shop',
      name: 'shop',
      component: shop
    },
    {
      path: '/imgDetaile',
      name: 'imgDetaile',
      component: imgDetaile
    },{
      path: '/familyimgDetaile',
      name: 'familyimgDetaile',
      component: familyimgDetaile
    },{
      path: '/invitationShare',
      name: 'invitationShare',
      component: invitationShare
    },{
      path: '/fiveSteps',
      name: 'fiveSteps',
      component: fiveSteps
    },{
      path: '/courseShare',
      name: 'courseShare',
      component: courseShare
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js